import {
  PopoverFooter,
  type PopoverFooterProps,
} from '@frontend/legacy-components';

export type FindingFooterActionsProps = PopoverFooterProps;
/**
 * Layout wrapper for footer actions in a finding popover or flyout.
 * Consumers compose action leaf components as children.
 */
export const FindingFooterActions = ({
  children,
  as: Wrapper = PopoverFooter,
  ...rest
}: FindingFooterActionsProps) => {
  return (
    <Wrapper
      display="flex"
      borderTop="1px solid"
      borderColor="separator.divider"
      bg="page.background"
      justifyContent="space-between"
      borderBottomRadius="md"
      height="auto"
      py={1}
      px={1.5}
      {...rest}
    >
      {children}
    </Wrapper>
  );
};
